import { render, staticRenderFns } from "./ysxkzTx.vue?vue&type=template&id=ce158aa2&scoped=true&"
import script from "./ysxkzTx.vue?vue&type=script&lang=js&"
export * from "./ysxkzTx.vue?vue&type=script&lang=js&"
import style0 from "./ysxkzTx.vue?vue&type=style&index=0&id=ce158aa2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce158aa2",
  null
  
)

export default component.exports